<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'sendTime')">
              <a-range-picker v-model='queryParam.sendTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple' v-model='queryParam.mainSids' :max-tag-count="2">
                <a-select-option v-for='item in mainAppList' :key='item.appssid' :value='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="'查询类型'">
              <a-select default-value="" style="width: 180px" v-model="queryParam.queryType">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="1">
                  主产品首贷申请数
                </a-select-option>
                <a-select-option value="2">
                  主产品复贷申请数
                </a-select-option>
                <a-select-option value="3">
                  子产品首贷申请数
                </a-select-option>
                <a-select-option value="4">
                  子产品复贷申请数
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row :gutter='12'>
          <a-col :md="8" :sm="16">
            <a-form-item :label="'模型类型'">
              <a-select mode='multiple' v-model='queryParam.modelVersions' :max-tag-count="2">
                <a-select-option v-for='item in modelVersionList' :key='item.modelVersion' :value='item.modelVersionValue'>
                  {{ item.modelVersion }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row> -->
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            <a-button type='primary' @click="downLoadData()" icon='download' style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
          </a-col>
        </a-row>
      </a-form>

      <a-card title="汇总数据" size="small" style="margin-bottom: 16px;">
        <a-table
          :columns="summaryColumns"
          :dataSource="summaryData"
          row-key="uid"
          :pagination="false"
          :show-header="true"
          size="small"
          bordered
        />
      </a-card>

      <a-table
        ref='table'
        row-key="index"
        size='middle'
        :columns='columns'
        :dataSource='displayData'
        :pagination='false'
        :loading='loading'
        bordered
      />
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryApplyAmtOrderInfo, queryApplyAmtSumOrderInfo, getApplistExcludingSubApp } from '@/webpublicapi/order'
import moment from 'moment'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  data() {
    return {
      I18N_KEY,
      mainAppList: [],
      // modelVersionList: [],
      sum: {},
      form: { pageNum: 1, pageSize: 10 },
      total: 0,
      dataSource: [],        // 原始数据
      displayData: [],       // 用于展示的数据（申请数已累加）
      mergeConfig: {},       // 合并配置
      columns: [],
      queryParam: { tradeType: null, sendTime: [], mainSids: [], queryType: null },
      loading: false,
      queryTypeMap: {
        '': '申请数',
        '1': '主产品首贷申请数',
        '2': '主产品复贷申请数',
        '3': '子产品首贷申请数',
        '4': '子产品复贷申请数'
      }
    }
  },
  computed: {
    summaryColumns() {
      return [
        { key: 'applyOrderNumSum', title: '申请数-汇总', align: 'left', dataIndex: 'applyOrderNumSum' },
        { key: 'averageAmountSum', title: '件均额度-汇总', align: 'left', dataIndex: 'averageAmountSum' },
        { key: 'passOrderNumSum', title: '通过数-汇总', align: 'left', dataIndex: 'passOrderNumSum' },
        { key: 'passRateSum', title: '通过率-汇总', align: 'left', dataIndex: 'passRateSum' }
      ]
    },
    summaryData() {
      const data = this.sum || {}
      return [
        {
          uid: 'SUMMARY_ROW_UNIQUE_KEY',
          applyOrderNumSum: this.formatNumber(data.applyOrderNum),
          passOrderNumSum: this.formatNumber(data.passOrderNum),
          averageAmountSum: this.formatNumber(data.averageAmount),
          passRateSum: data.passRate
        }
      ]
    },
    dynamicApplyTitle() {
      return this.queryTypeMap[this.queryParam.queryType] || '申请数'
    }
  },
  created() {
    this.initColumns()
    this.loadSelectData()
    this.loadData()
  },
  methods: {
    initColumns() {
      // 使用 customCell 实现单元格合并
      const createMergeCell = (dataIndex) => (record, rowIndex) => {
        const config = this.mergeConfig[dataIndex]
        if (!config) return {}
        const cellConfig = config[rowIndex]
        if (!cellConfig) return {}
        return {
          attrs: {
            rowSpan: cellConfig.rowSpan
          },
          style: cellConfig.rowSpan === 0 ? { display: 'none' } : {}
        }
      }

      this.columns = [
        { 
          title: '日期', 
          align: 'left', 
          dataIndex: 'date',
          customCell: createMergeCell('date')
        },
        { 
          title: '盘号', 
          align: 'left', 
          dataIndex: 'appSsid',
          customCell: createMergeCell('appSsid')
        },
        { 
          title: this.dynamicApplyTitle, 
          align: 'left', 
          dataIndex: 'applyOrderNum',
          customCell: createMergeCell('applyOrderNum')
        },
        // { title: '模型版本', align: 'left', dataIndex: 'modelVersion' },
        // { title: '分数', align: 'left', dataIndex: 'modelScoreRange' },
        { title: '申请额度', align: 'left', dataIndex: 'averageAmount' },
        { title: '通过数', align: 'left', dataIndex: 'passOrderNum' },
        { title: '占比', align: 'left', dataIndex: 'applyOrderRate' },
        { 
          title: '通过率', 
          align: 'left', 
          dataIndex: 'passRate',
          customCell: createMergeCell('passRate')
        }
      ]
    },

    formatNumber(v) { return v == null ? 0 : Number(v).toLocaleString() },
    
    loadSelectData() {
      getApplistExcludingSubApp().then(res => res.data && (this.mainAppList = res.data))
      // getRiskModelVersion().then(res => res.data && (this.modelVersionList = res.data))
    },
    
    searchQuery() { 
      this.form.pageNum = 1
      // 重新初始化列，让申请数列名根据当前 queryType 更新
      this.initColumns()
      this.loadData() 
    },

    // 核心：计算合并配置 + 累加申请数
    buildMergeConfigAndSumApply() {
      const list = this.dataSource
      this.mergeConfig = {}
      if (!list.length) {
        this.displayData = []
        return
      }

      // 按 date + appSsid + passRate 分组
      const groups = []
      let start = 0
      let groupKey = `${list[0].date}_${list[0].appSsid}_${list[0].passRate}`

      for (let i = 1; i < list.length; i++) {
        const currKey = `${list[i].date}_${list[i].appSsid}_${list[i].passRate}`
        if (currKey !== groupKey) {
          groups.push({ startIndex: start, rowCount: i - start })
          start = i
          groupKey = currKey
        }
      }
      groups.push({ startIndex: start, rowCount: list.length - start })

      // 深拷贝原始数据作为展示数据
      this.displayData = list.map(item => ({ ...item }))

      // 初始化合并配置
      const dateConfig = {}
      const appSsidConfig = {}
      const applyOrderNumConfig = {}
      const passRateConfig = {}

      groups.forEach(g => {
        const { startIndex, rowCount } = g
        
        // 累加组内申请数
        let sumApply = 0
        for (let i = startIndex; i < startIndex + rowCount; i++) {
          sumApply += Number(this.displayData[i].applyOrderNum || 0)
        }
        // 首行显示累加后的申请数
        this.$set(this.displayData, startIndex, {
          ...this.displayData[startIndex],
          applyOrderNum: sumApply
        })

        // 首行设置 rowSpan
        dateConfig[startIndex] = { rowSpan: rowCount }
        appSsidConfig[startIndex] = { rowSpan: rowCount }
        applyOrderNumConfig[startIndex] = { rowSpan: rowCount }
        passRateConfig[startIndex] = { rowSpan: rowCount }

        // 其余行设置 rowSpan: 0（隐藏）
        for (let offset = 1; offset < rowCount; offset++) {
          const rowIdx = startIndex + offset
          dateConfig[rowIdx] = { rowSpan: 0 }
          appSsidConfig[rowIdx] = { rowSpan: 0 }
          applyOrderNumConfig[rowIdx] = { rowSpan: 0 }
          passRateConfig[rowIdx] = { rowSpan: 0 }
        }
      })

      this.mergeConfig = {
        date: dateConfig,
        appSsid: appSsidConfig,
        applyOrderNum: applyOrderNumConfig,
        passRate: passRateConfig
      }
    },

    loadData() {
      const p = this.getQueryParams()
      if (!p) return
      this.loading = true
      Promise.all([
        queryApplyAmtOrderInfo(p),
        queryApplyAmtSumOrderInfo(p)
      ]).then(([resList, resSum]) => {
        if (resList.code === 1000) {
          const rows = resList.data.rows || []
          this.dataSource = rows.map((item, index) => ({ ...item, index }))
          this.total = resList.data.total || 0
          this.buildMergeConfigAndSumApply()
        }
        if (resSum.code === 1000) {
          this.sum = (Array.isArray(resSum.data) && resSum.data.length > 0) ? resSum.data[0] : {}
        }
      }).catch(err => console.error(err))
        .finally(() => this.loading = false)
    },
    
    transformTime: t => moment(t).format('YYYY-MM-DD'),
    
    getQueryParams() {
      const { sendTime } = this.queryParam
      const d = {
        ...this.queryParam,
        submitStartTime: sendTime?.length ? this.transformTime(sendTime[0]) : null,
        submitEndTime: sendTime?.length ? this.transformTime(sendTime[1]) : null,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      delete d.sendTime
      return filterObj(d)
    },
    
    async downLoadData() {
      const p = this.getQueryParams()
      delete p.pageNum; delete p.pageSize
      this.loading = true
      try { 
        await exportFileByPost('/api/web/webpublic/platform/order/exportApplyAmtOrderInfo', p, '申请额度订单详情报表.xlsx') 
      } catch (e) { 
        this.$message.error(e.message) 
      } finally { 
        this.loading = false 
      }
    },
    
    handleTableChange(pn, ps) { 
      this.form.pageNum = pn
      this.form.pageSize = ps
      this.loadData() 
    },
    
    searchReset() {
      this.queryParam = { tradeType: null, sendTime: [], mainSids: [], queryType: null }
      this.form = { pageNum: 1, pageSize: 10 }
      // 重置时也要重新初始化列
      this.initColumns()
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>